import { ToggleIcons } from './ToggleIcons'
import { onClick } from './useAIChatButtonActions'
import { useChatbotEvents } from './useAIChatButtonActions'
import { getPositionClasses, useBannerHeight } from './useAIChatPositioning'

type AIChatButtonProps = {
  readonly isPromoActive: boolean
  readonly isPromoBannerVisible: boolean
  readonly onCloseBanner: () => void
  readonly widgetId: string
}

export function AIChatButton({
  isPromoActive,
  isPromoBannerVisible,
  onCloseBanner,
  widgetId
}: AIChatButtonProps) {
  // Used to toggle the classes for the ToggleIcons component (visual state of the icon)
  const chatbotIsOpen = useChatbotEvents(widgetId)
  // Get the height of the bottom mobile banner after it has opened
  const bannerHeight = useBannerHeight(isPromoBannerVisible)

  return (
    <div
      className={`z-50 fixed right-4 lg:right-6 lg:bottom-6 ${getPositionClasses(isPromoActive, isPromoBannerVisible)}`}
      style={{ marginBottom: `${bannerHeight}px` }}
    >
      <button
        className="flex justify-center items-center btn btn-solid-primary hover:scale-105 text-white border-solid border-solid-primary border-4"
        style={{
          height: '52px',
          width: '52px',
          padding: '0px',
          borderRadius: '999px'
        }}
        onClick={onClick(isPromoBannerVisible, onCloseBanner, widgetId)}
        type="button"
        aria-controls="chat-window"
        aria-label="Chat with our AI assistant"
      >
        <ToggleIcons isOpen={chatbotIsOpen} />
      </button>
    </div>
  )
}
